export default __webpack_public_path__ + "static/media/ic-edit.d5f18933.svg";